import {createUseStyles} from 'react-jss';
import MediaQueries from '../../../v2/style-helper/MediaQueries';
import Spacing from '../../../v2/style-helper/Spacing';

export default createUseStyles({
  optionalDeliveryBasketItem: {
    marginBottom: Spacing.double,
  },
  optionalDeliveryBasketItemContents: {
    padding: Spacing.single,
    border: props => ['1px', 'solid', props.theme.core.borderColor],
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    minHeight: 'auto',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    width: '100%',
    flex: 1,
    [MediaQueries.phone]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  information: {
    display: 'flex',
    maxWidth: '60%',
    marginRight: Spacing.single,
    [MediaQueries.phone]: {
      marginBottom: Spacing.double,
      marginRight: 0,
      maxWidth: '100%',
    },
  },
  icon: {
    marginRight: 8,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    '& svg': {
      width: 36,
      height: 24,
    },
  },
  text: {
    marginLeft: Spacing.single,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  title: {
    fontSize: props => props.theme.base.fontSize,
    fontWeight: props => props.theme.core.boldFontWeight,
    margin: 0,
    lineHeight: 1.3,
  },
  description: {
    fontSize: props => props.theme.base.fontSize,
    margin: 0,
    lineHeight: 1.3,
  },
  descriptionExtra: {
    fontSize: 12,
    margin: 0,
    marginTop: Spacing.double,
    lineHeight: 1.3,
    padding: [0, 8],
  },
  loginMessage: {
    fontSize: props => props.theme.base.fontSize,
    margin: [Spacing.half, 0],
  },
  button: {
    width: '200px !important',
    height: '45px',
    fontSize: '14px',
    [MediaQueries.phone]: {
      width: '100% !important',
    },
  },
  infoMessage: {
    marginBottom: Spacing.double,
  },
  editBasketError: {
    paddingTop: Spacing.single,
    marginTop: Spacing.single,
  },
});
